/******* AUTO-GENERATED FILE *********

Run `yarn icon:typings` to re-generate using updated selection.json

**/
export enum Icons {
  HOLIDAY = "holiday",
  PRIORITY = "priority",
  SHOPPINGBAG = "shoppingBag",
  CURRENCYPOUND = "currencyPound",
  ORDERDESC = "orderDesc",
  ORDERASC = "orderAsc",
  NUMBERS = "numbers",
  CREDIT = "credit",
  LINEGRAPH = "lineGraph",
  BARCHART = "barChart",
  EXITEDIT = "exitEdit",
  FULLSCREEN = "fullscreen",
  FULLSCREENEXIT = "fullscreenExit",
  DASHBOARDEDIT = "dashboardEdit",
  EMAIL = "email",
  PHONE = "phone",
  GROUPS = "groups",
  BOLT = "bolt",
  LUPIN = "lupin",
  PEANUTS = "peanuts",
  SULPHITES = "sulphites",
  PORK = "pork",
  FISH = "fish",
  MOLLUSCS = "molluscs",
  SUGAR = "sugar",
  CORN = "corn",
  TRANSFATS = "transfats",
  SOY = "soy",
  GMO = "GMO",
  CELERY = "celery",
  SHELLFISH = "shellfish",
  ALCOHOL = "alcohol",
  VEGAN = "vegan",
  NUTS = "nuts",
  MEAT = "meat",
  MUSTARD = "mustard",
  ATTACH = "attach",
  OPENNEW = "openNew",
  HALAL = "halal",
  SESAME = "sesame",
  SUBSTITUTION = "substitution",
  WARN = "warn",
  PENDING = "pending",
  QUEUE = "queue",
  PROMOTION = "promotion",
  BELL = "bell",
  SPEECHBUBBLE = "speechBubble",
  PAN = "pan",
  FROZEN = "frozen",
  OVEN = "oven",
  SYNC = "sync",
  DAIRY = "dairy",
  WHEAT = "wheat",
  ADVISORY = "advisory",
  SHELLFISH1 = "shellfish1",
  EGG = "egg",
  VEGAN1 = "vegan1",
  SEARCH = "search",
  BRANCH = "branch",
  PEOPLE = "people",
  PEOPLEOUTLINE = "peopleOutline",
  PEOPLEADMIN = "peopleAdmin",
  PERSON = "person",
  NOTES = "notes",
  BURGERMENU = "burgerMenu",
  PLAY = "play",
  PRODUCT = "product",
  PRICE = "price",
  LAYERS = "layers",
  LOGOUT = "logout",
  CATEGORY = "category",
  PERSONCIRCLE = "personCircle",
  LORRY = "lorry",
  REFRESH = "refresh",
  CIRCLE = "circle",
  DELETE = "delete",
  CART = "cart",
  EDIT = "edit",
  GRID = "grid",
  HOURGLASSFILLED = "hourGlassFilled",
  HOURGLASSEMPTY = "hourGlassEmpty",
  FILTER = "filter",
  TABLE = "table",
  ERRORCIRCLE = "errorCircle",
  TICK = "tick",
  CLOSECIRCLE = "closeCircle",
  DOWNLOAD = "download",
  INFO = "info",
  HELP = "help",
  SUPPORT = "support",
  DRAG = "drag",
  HORIZONTALDRAG = "horizontalDrag",
  SETTINGS = "settings",
  HOME = "home",
  CALENDAR = "calendar",
  CLOSE = "close",
  CHEVRONDOWN = "chevronDown",
  CHEVRONUP = "chevronUp",
  CHEVRONRIGHT = "chevronRight",
  CHEVRONLEFT = "chevronLeft",
  ADD = "add",
  KEYBOARD = "keyboard",
  KEYBOARD_RETURN = "keyboard_return",
  KEYBOARD_CONTROL = "keyboard_control",
  KEYBOARD_TAB = "keyboard_tab",
  COLUMNS = "columns",
  WASTE = "waste",
  VAN = "van",
  ALARM = "alarm",
  PRINTER = "printer",
}